import React from 'react';
import { SearchIcon, ArrowRightIcon, MailIcon } from 'lucide-react';
export function People() {
  return <section id="people" className="py-20 lg:py-28 bg-white" data-id="element-371">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10" data-id="element-372">
        {/* Section Header */}
        <div className="reveal flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6" data-id="element-373">
          <div data-id="element-374">
            <span className="text-xs uppercase tracking-wider text-tlfc-gold font-medium" data-id="element-375">
              Our People
            </span>
            <h2 className="mt-4 font-serif text-3xl md:text-4xl text-tlfc-text" data-id="element-376">
              Meet your legal team
            </h2>
            <p className="mt-3 text-tlfc-text-secondary text-lg" data-id="element-377">
              Find the right specialist for your matter.
            </p>
          </div>

          {/* Search Bar */}
          <div className="relative w-full max-w-md" data-id="element-378">
            <SearchIcon className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-tlfc-muted" aria-hidden="true" data-id="element-379" />
            <input type="text" placeholder="Search by name or expertise" className="w-full bg-tlfc-cream border border-tlfc-border rounded-lg pl-12 pr-4 py-3.5 text-sm text-tlfc-text placeholder:text-tlfc-muted focus:border-tlfc-gold focus:outline-none transition-colors" aria-label="Search people" data-id="element-380" />
          </div>
        </div>

        {/* People Grid */}
        <div className="reveal-stagger mt-12 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-381">
          {/* Michael Fetter */}
          <div className="group bg-tlfc-cream border border-tlfc-border rounded-xl overflow-hidden card-hover hover:border-tlfc-gold/40" data-id="element-382">
            <div className="relative aspect-[3/4] overflow-hidden" data-id="element-383">
              <img src="https://cdn.magicpatterns.com/uploads/6W1TPt1S6LJKXjDJUkPLYw/Michael-Fetter.jpg" alt="Michael Fetter, Principal" className="absolute inset-0 w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105" data-id="element-384" />
              <div className="absolute inset-0 bg-gradient-to-t from-tlfc-dark/60 via-transparent to-transparent" data-id="element-385" />
            </div>
            <div className="p-5" data-id="element-386">
              <h3 className="font-serif text-lg text-tlfc-text group-hover:text-tlfc-gold transition-colors" data-id="element-387">
                Michael Fetter
              </h3>
              <p className="mt-1 text-sm text-tlfc-text-secondary" data-id="element-388">Principal</p>
              <div className="flex flex-wrap gap-2 mt-3" data-id="element-389">
                <span className="text-xs bg-white border border-tlfc-border rounded-full px-3 py-1 text-tlfc-muted" data-id="element-390">
                  Business
                </span>
                <span className="text-xs bg-white border border-tlfc-border rounded-full px-3 py-1 text-tlfc-muted" data-id="element-391">
                  Corporate
                </span>
              </div>
              <a href="#contact" className="inline-flex items-center gap-1.5 mt-4 text-sm text-tlfc-gold font-medium" data-id="element-392">
                <MailIcon className="w-3.5 h-3.5" aria-hidden="true" data-id="element-393" />
                Contact
              </a>
            </div>
          </div>

          {/* Jonathan Tisher */}
          <div className="group bg-tlfc-cream border border-tlfc-border rounded-xl overflow-hidden card-hover hover:border-tlfc-gold/40" data-id="element-394">
            <div className="relative aspect-[3/4] overflow-hidden" data-id="element-395">
              <img src="https://cdn.magicpatterns.com/uploads/iafrfR6fQ94vNF5sRTcVtT/Jonathan-Tisher.jpg" alt="Jonathan Tisher, Principal" className="absolute inset-0 w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105" data-id="element-396" />
              <div className="absolute inset-0 bg-gradient-to-t from-tlfc-dark/60 via-transparent to-transparent" data-id="element-397" />
            </div>
            <div className="p-5" data-id="element-398">
              <h3 className="font-serif text-lg text-tlfc-text group-hover:text-tlfc-gold transition-colors" data-id="element-399">
                Jonathan Tisher
              </h3>
              <p className="mt-1 text-sm text-tlfc-text-secondary" data-id="element-400">
                Principal, Accredited Property Law Specialist
              </p>
              <div className="flex flex-wrap gap-2 mt-3" data-id="element-401">
                <span className="text-xs bg-white border border-tlfc-border rounded-full px-3 py-1 text-tlfc-muted" data-id="element-402">
                  Property
                </span>
              </div>
              <a href="#contact" className="inline-flex items-center gap-1.5 mt-4 text-sm text-tlfc-gold font-medium" data-id="element-403">
                <MailIcon className="w-3.5 h-3.5" aria-hidden="true" data-id="element-404" />
                Contact
              </a>
            </div>
          </div>

          {/* Ron Cohen */}
          <div className="group bg-tlfc-cream border border-tlfc-border rounded-xl overflow-hidden card-hover hover:border-tlfc-gold/40" data-id="element-405">
            <div className="relative aspect-[3/4] overflow-hidden" data-id="element-406">
              <img src="https://cdn.magicpatterns.com/uploads/1GF2KgvbhSd1uXZR7vW7ya/Ron-Cohen.jpg" alt="Ron Cohen, Principal" className="absolute inset-0 w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105" data-id="element-407" />
              <div className="absolute inset-0 bg-gradient-to-t from-tlfc-dark/60 via-transparent to-transparent" data-id="element-408" />
            </div>
            <div className="p-5" data-id="element-409">
              <h3 className="font-serif text-lg text-tlfc-text group-hover:text-tlfc-gold transition-colors" data-id="element-410">
                Ron Cohen
              </h3>
              <p className="mt-1 text-sm text-tlfc-text-secondary" data-id="element-411">Principal</p>
              <div className="flex flex-wrap gap-2 mt-3" data-id="element-412">
                <span className="text-xs bg-white border border-tlfc-border rounded-full px-3 py-1 text-tlfc-muted" data-id="element-413">
                  Litigation
                </span>
              </div>
              <a href="#contact" className="inline-flex items-center gap-1.5 mt-4 text-sm text-tlfc-gold font-medium" data-id="element-414">
                <MailIcon className="w-3.5 h-3.5" aria-hidden="true" data-id="element-415" />
                Contact
              </a>
            </div>
          </div>

          {/* Simon Abraham */}
          <div className="group bg-tlfc-cream border border-tlfc-border rounded-xl overflow-hidden card-hover hover:border-tlfc-gold/40" data-id="element-416">
            <div className="relative aspect-[3/4] overflow-hidden" data-id="element-417">
              <img src="https://cdn.magicpatterns.com/uploads/a4rrqdj7SpSR7Qpf2aejsp/Simon-Abraham.webp" alt="Simon Abraham, Principal" className="absolute inset-0 w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105" data-id="element-418" />
              <div className="absolute inset-0 bg-gradient-to-t from-tlfc-dark/60 via-transparent to-transparent" data-id="element-419" />
            </div>
            <div className="p-5" data-id="element-420">
              <h3 className="font-serif text-lg text-tlfc-text group-hover:text-tlfc-gold transition-colors" data-id="element-421">
                Simon Abraham
              </h3>
              <p className="mt-1 text-sm text-tlfc-text-secondary" data-id="element-422">
                Principal, Accredited Commercial Litigation Specialist
              </p>
              <div className="flex flex-wrap gap-2 mt-3" data-id="element-423">
                <span className="text-xs bg-white border border-tlfc-border rounded-full px-3 py-1 text-tlfc-muted" data-id="element-424">
                  Commercial Litigation
                </span>
              </div>
              <a href="#contact" className="inline-flex items-center gap-1.5 mt-4 text-sm text-tlfc-gold font-medium" data-id="element-425">
                <MailIcon className="w-3.5 h-3.5" aria-hidden="true" data-id="element-426" />
                Contact
              </a>
            </div>
          </div>
        </div>

        {/* CTA */}
        <div className="reveal mt-10 text-center" data-id="element-427">
          <a href="#" className="inline-flex items-center gap-2 text-tlfc-gold font-medium hover:text-tlfc-gold-light transition-colors group" data-id="element-428">
            Browse all team members
            <ArrowRightIcon className="w-4 h-4 transition-transform group-hover:translate-x-1" aria-hidden="true" data-id="element-429" />
          </a>
        </div>
      </div>
    </section>;
}